// Runtime uses Quill's ESM default export. TypeScript resolves this module to
// the local compatibility declaration configured in tsconfig.paths.json.
import Quill from 'quill'

export const createQuillEditor = (container, options) => new Quill(container, options)
